import React from "react";
import _ from "lodash";
import AdHocTransferItem from "./AdHocTransferItem";
import { makeStyles } from "@material-ui/core/styles";

const AdHocRequestsTable = ({
  transfers,
  updatedTransfers,
  roles,
  transferMode,
  setCurrentTransferId,
  setCurrentBookingId,
  setShowVehicleModal,
  setErrorMessage,
  setCurrentTransferData,
  setShowScheduleModal,
  setShowScheduleModalAssignVehicleOption,
  setConflictDialogData
}: any) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.table}>
        <div className={classes.tableHead}>
          <div className={classes.multiLoadColumn}></div>
          <div className={classes.pickupTimeColumn}>Pickup time</div>
          <div className={classes.patientColumn}>Patient</div>
          <div className={classes.needsColumn}>Needs</div>
          <div className={classes.fromColumn}>From</div>
          <div className={classes.toColumn}>To</div>
          <div className={classes.priorityColumn}>Pri</div>
          <div className={classes.statusColumn}>Status</div>
          <div className={classes.actionButtonColumn}></div>
        </div>

        {transfers.map((row: any) => {
          if (transferMode == 1 && !row.assignedToMe && roles.isSMADriver) return null;
          if (transferMode == 1 && row.assignedVehicle != null && roles.isAdmin) return null;
          return (
            <AdHocTransferItem
              key={row.transferId}
              transferRequest={row}
              updatedTransfers={updatedTransfers}
              roles={roles}
              setCurrentTransferId={setCurrentTransferId}
              setCurrentBookingId={setCurrentBookingId}
              setShowVehicleModal={setShowVehicleModal}
              setErrorMessage={setErrorMessage}
              setCurrentTransferData={setCurrentTransferData}
              setShowScheduleModal={setShowScheduleModal}
              setShowScheduleModalAssignVehicleOption={setShowScheduleModalAssignVehicleOption}
              setConflictDialogData={setConflictDialogData}
            />
          );
        })}

        {transfers.length === 0 && <div className={classes.noTransfersText}>No Records Found</div>}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  root: {},
  table: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    // maxHeight: "280px",
    overflowY: "auto",
  },
  tableHead: {
    height: 43,
    minHeight: 43,
    maxHeight: 43,
    backgroundColor: "#02489D",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",

    "& > div": {
      color: "rgba(255, 255, 255, 0.3)",
    },
  },
  multiLoadColumn: {
    flex: "0 0 53px",
    display: "flex",
    justifyContent: "center",
    height: "100%",
  },
  patientColumn: {
    paddingLeft: 10,
    flex: "1 1 169px",
    display: "flex",

    "& span": {
      color: "#010B18",
      opacity: "0.39",
    },

    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  pickupTimeColumn: {
    paddingLeft: 15,
    flex: "0 0 171px",
  },
  needsColumn: {
    paddingLeft: 15,
    flex: "0 0 164px",
    display: "flex",
    alignItems: "center",

    "& img": {
      width: 18,
      height: 18,
    },
    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  fromColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  toColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  priorityColumn: {
    flex: "0 0 47px",
  },
  statusColumn: {
    flex: "1 1 245px",
  },
  actionButtonColumn: {
    paddingLeft: 15,
    paddingRight: 10,
    flex: "0 0 32px",
    display: "flex",
    justifyContent: "flex-end",
  },
  noTransfersText: {
    display: "flex",
    justifyContent: "center",
    fontWeight: 500,
    backgroundColor: "rgb(2, 72, 157, 0.23)",
    height: 55,
    fontSize: "18px",
    lineHeight: "22px",
    alignItems: "center",
  },
});

export default AdHocRequestsTable;
